import { render, staticRenderFns } from "./Sidenav4.vue?vue&type=template&id=5fb29e51&scoped=true&"
import script from "./Sidenav4.vue?vue&type=script&lang=js&"
export * from "./Sidenav4.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav4.vue?vue&type=style&index=0&id=5fb29e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb29e51",
  null
  
)

export default component.exports